import { cn } from '@/lib/utils';
import type { HistoryTab } from './types';

interface HistoryTabsProps {
  tabs: HistoryTab[];
  activeId: string;
  onChange: (id: string) => void;
  /** Row count per tab; defaults to the rows each tab holds. */
  counts?: Record<string, number>;
}

export function HistoryTabs({ tabs, activeId, onChange, counts }: HistoryTabsProps) {
  return (
    <div role="tablist" className="flex gap-1">
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={cn(
              '-mb-px inline-flex h-11 items-center gap-1.5 border-b-2 px-2.5 text-sm font-semibold',
              active ? 'border-[#4369a0] text-[#4369a0]' : 'border-transparent text-gray-500 hover:text-gray-700'
            )}
          >
            {tab.label}
            <span
              className={cn(
                'inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px]',
                active ? 'bg-[#4369a0]/10 text-[#4369a0]' : 'bg-gray-100 text-gray-600'
              )}
            >
              {counts?.[tab.id] ?? tab.rows.length}
            </span>
          </button>
        );
      })}
    </div>
  );
}
